// The switchable languages, as data — no React, no store, so both the
// preferences provider (theme/PreferencesContext) and the switch component can
// import this without a cycle.
//
// The two values the server stores (see the services user preferences, and
// mobileapp/src/theme/PreferencesContext.tsx). Deliberately the app's own words
// rather than BCP-47 codes, so one account's choice means the same thing in the
// webapp and the mobile app.
export type Language = 'bengali' | 'english';

/**
 * In the order they are offered. Each is labelled in its OWN script and never
 * translated — someone who has landed in a language they can't read has to be
 * able to find their way back out, which they can't do if "Bengali" is
 * currently rendered as "বাংলা ভাষা" and vice versa.
 */
export const LANGUAGES: ReadonlyArray<{ id: Language; label: string }> = [
  { id: 'english', label: 'English' },
  { id: 'bengali', label: 'বাংলা' },
];

export const isLanguage = (value: unknown): value is Language =>
  value === 'english' || value === 'bengali';

// The <html lang> value for each language — screen readers and the browser's
// own translation prompt read this, so it has to be a real BCP-47 tag even
// though we store our own words.
export const HTML_LANG: Record<Language, string> = {
  english: 'en',
  bengali: 'bn',
};
